import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { WebMessageStatus } from 'src/app/common/constants/webmessage-status.constants';
import { AbstractRtpConfigurationService } from '../abstraction/abstract.rtp-configuration.service';
import { IRtpTransactionalSettings } from '../../interfaces/configuration/rtp-transactional-settings.interface';

@Injectable({
  providedIn: 'root',
})
export class MockRtpConfigurationService extends AbstractRtpConfigurationService {
  private getRtpTransactionalSettingsJson =
    'assets/mocks/configuration/getRtpTransactionalSettings.json';
  private transactionalSettings: IRtpTransactionalSettings | null = null;

  constructor(private http: HttpClient) {
    super();
  }

  getRtpTransactionalSettings(
    routingNumber: string
  ): Promise<IRtpTransactionalSettings | undefined> {
    if (this.transactionalSettings) {
      return Promise.resolve({ ...this.transactionalSettings });
    }

    return lastValueFrom(
      this.http.get<IRtpTransactionalSettings>(this.getRtpTransactionalSettingsJson)
    ).then(settings => {
      this.transactionalSettings = { ...settings };
      return { ...settings };
    });
  }

  async updateRtpTransactionalSettings(
    settings: IRtpTransactionalSettings
  ): Promise<IWebMessage | undefined> {
    if (!this.transactionalSettings) {
      await this.getRtpTransactionalSettings(settings.routingNumber);
    }

    const updatedSettings = { ...settings };
    delete updatedSettings.originalObject;
    this.transactionalSettings = updatedSettings;

    return {
      status: WebMessageStatus.Success,
      message: 'RTP transactional settings saved successfully.',
      object: null,
    };
  }
}
